// تنسيق المبالغ في نظام الحسابات: فاصلة كل ٣ خانات وبدون كسور (أرقام صحيحة)

/** عرض مبلغ: "1,250,000" (مدوّر لأقرب عدد صحيح، فاصلة آلاف، بدون كسور). */
export const fmtMoney = (n?: number | null): string =>
  new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Math.round(Number(n) || 0))

/** خصائص حقل الإدخال الرقمي (عدد صحيح + فاصلة آلاف حيّة) لاستخدامها مع Ant InputNumber.
 *  مثال: <InputNumber {...moneyInputProps} value={x} onChange={...} /> */
export const moneyInputProps = {
  min: 0,
  step: 1,
  precision: 0 as const,
  formatter: (v: string | number | undefined): string =>
    v === undefined || v === null || `${v}` === ''
      ? ''
      : new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(
          Math.round(Number(v) || 0),
        ),
  parser: (v?: string): string => (v ?? '').replace(/[^\d]/g, ''),
}
